/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function LiveStreamingIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="live-streaming"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M16.992 8.672A6 6 0 0 1 16.992 15.328" data-tinysvg-shape="arc" data-tinysvg-arc="12 12 6 6 326.31 33.69 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M20.4 5.7A10.5 10.5 0 0 1 20.4 18.3" data-tinysvg-shape="arc" data-tinysvg-arc="12 12 10.5 10.5 323.13 36.87 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M7.008 15.328A6 6 0 0 1 7.008 8.672" data-tinysvg-shape="arc" data-tinysvg-arc="12 12 6 6 146.31 213.69 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M3.6 18.3A10.5 10.5 0 0 1 3.6 5.7" data-tinysvg-shape="arc" data-tinysvg-arc="12 12 10.5 10.5 143.13 216.87 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <circle cx={12} cy={12} r={2} stroke={color} fill={color} data-stroke-tone="primary" data-fill-tone="primary" />
    </svg>
  )
}
